import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { LabelText, LittleSubHeadline, LittleText, MediumText, NotificationText } from "../../../../components/typography";
import { FixedBodyDiv, TitleSpan } from "../team/view-team";
import { StructureItem, StructureItems, StructureSection } from "./main";
import { useStructureStore } from "../../../../assets/store/useStructureStore";
import { ObjectsEnum } from "../../../../assets/utils/enums/basket";
import { StructureObjectField } from "../../../../assets/utils/enums/structure-object";
import styled from "styled-components";
import { COLORS } from "../../../../assets/utils/enums/colors";
import Input, { InputStyle } from "../../../../components/ui/inputs";
import { useEffect, useState } from "react";
import { Button } from "../../../../components/ui/button";
import { StructureVisibleSwitch } from "../../../../components/ui/switch";
import toast from "react-hot-toast";
import CustomToast from "../../../../components/ui/custom-toast";
import { ToastTypeEnum } from "../../../../assets/utils/enums/toast";
import { DropdownWindow } from "../../../../components/ui/dropdown";

export default function UpdateFieldStructureTab() {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const structure = useStructureStore(
        (s) => s.structures[id as ObjectsEnum]
    );
    const updateVisibility = useStructureStore(
        (s) => s.updateFieldVisibility
    );

    const { updateField, deleteField } = useStructureStore();
    const selectedField: StructureObjectField = location.state;
    const [fieldLabel, setFieldLabel] = useState<string>(selectedField.label);
    const [isChangedField, setIsChangedField] = useState<boolean>(false);
    const [visibleStatus, setVisibleStatus] = useState<boolean>(selectedField.visible);

    if (!selectedField) {
        navigate(-1);
    }

    useEffect(() => {
        if (fieldLabel === "") {
            setIsChangedField(true);
            return;
        }
        // console.log(visibleStatus !== selectedField.visible)
        if (visibleStatus !== selectedField.visible) {
            setIsChangedField(false);
            return;
        }
        setIsChangedField(fieldLabel === selectedField.label);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fieldLabel, visibleStatus])

    return (
        <FixedBodyDiv
            className={`w-60 ${SETTINGS_BODY_DIV} gap-3`}
            $isPadding={true}
        >
            <TitleSpan className="pb-0">
                <div className="d-flex flex-row align-items-center gap-3">
                    <MediumText>Редагувати папки</MediumText>
                    <hr />
                    <span className="d-flex align-items-center gap-2">
                        <img src={structure.entityIcon} alt={structure.entityTitle} />
                        <MediumText>{structure.entityTitle}</MediumText>
                    </span>
                </div>
                <NotificationText>Налаштування полів вплине на структуру всіх записів у таблицях та папці. Ви можете організувати поля в групи і згорнути ті, які ви рідко використовуєте в структурі запису. Для отримання додаткової інформації щодо конструктора полів (папок), перейдіть до нашого <b className="fw-normal accent-text">Посібника Користувача.</b></NotificationText>
                <NotificationText className="accent-text">Дізнатися більше</NotificationText>
            </TitleSpan>

            <StructureSection className="gap-0">
                <TitleSpan className="pb-2">
                    <MediumText>{structure.fields.other.find(x => x.key === selectedField.key) ? "Пов’язані записи" : "Загальна інформація"}</MediumText>
                </TitleSpan>
                <StructureItems>
                    <StructureItem>
                        <img src={selectedField.icon} alt={selectedField.key} />
                        <MediumText>{selectedField.label}</MediumText>
                    </StructureItem>
                    <StructureItemsBody>
                        <LittleSubHeadline>Змінити назву запису</LittleSubHeadline>
                        <Input
                            attribute="text"
                            value={fieldLabel}
                            setValue={setFieldLabel}
                            errorText={""}
                            label=""
                            placeholder={selectedField.label}
                        />

                        <div className="d-flex flex-column gap-2 mt-2">
                            <LittleSubHeadline>Видимість елементу</LittleSubHeadline>
                            <span className="d-flex w-100 justify-content-between align-items-start gap-5">
                                <LittleText>Обмежити видимість поля. Ви не зможете бачити цей запис на сторінках папки <b className="accent-text fw-normal">“{structure.entityTitle}”</b></LittleText>
                                <StructureVisibleSwitch checked={visibleStatus} setChecked={setVisibleStatus}
                                />
                            </span>
                        </div>
                        {selectedField.isCreated && <div className="d-flex flex-column gap-2 mt-3">
                            <LittleSubHeadline>Видалити поле</LittleSubHeadline>
                            <span className="d-flex w-100 justify-content-between align-items-start gap-5">
                                <LittleText>Усі дані в цьому полі буде втрачено без можливості відновлення. <b className="accent-text fw-normal">Лише кастомні поля можуть бути видалені.</b></LittleText>
                                <Button
                                    bgcolor={COLORS.warning}
                                    txtcolor={`${COLORS.white} !important`}
                                    brcolor={COLORS.warning}
                                    width="35%"
                                    type="small"
                                    brradius="12px"
                                    className="gap-1"
                                    onClick={() => {
                                        if (selectedField.isCreated) {
                                            deleteField(structure.entity, selectedField);

                                            toast((t) => <CustomToast
                                                t={t}
                                                text={"Поле видалено."}
                                                type={ToastTypeEnum.SUCCESS}
                                            />)
                                            navigate(-1);
                                        }
                                    }}
                                >
                                    {/* <img src={deleteIcon} width={24} height={24} alt="delete-icon" /> */}
                                    <LittleSubHeadline>Видалити</LittleSubHeadline>
                                </Button>
                            </span>
                        </div>}
                        <div className="w-100 d-flex gap-2 justify-content-end mt-4">
                            <Button
                                bgcolor={COLORS.gray}
                                txtcolor={COLORS.secondary1}
                                brcolor={COLORS.gray}
                                width="30%"
                                type="large"
                                brradius="24px"
                                onClick={() => navigate(-1)}
                            >
                                <LittleSubHeadline>Скасувати</LittleSubHeadline>
                            </Button>
                            <Button
                                bgcolor={COLORS.secondary1}
                                txtcolor={`${COLORS.white} !important`}
                                brcolor={"transparent"}
                                width="35%"
                                type="large"
                                brradius="24px"
                                disabled={isChangedField}
                                $noactive={isChangedField}
                                // className="px-4 my-3 border-2"
                                onClick={() => {
                                    updateField(structure.entity, selectedField.key, {
                                        label: fieldLabel,
                                    });
                                    updateVisibility(
                                        structure.entity,
                                        selectedField.key,
                                        visibleStatus
                                    );
                                    navigate(-1);
                                }}
                            >
                                <LittleSubHeadline>Підтвердити зміни</LittleSubHeadline>
                            </Button>
                        </div>
                    </StructureItemsBody>
                </StructureItems>
            </StructureSection>

        </FixedBodyDiv>
    )
}

export const StructureItemsBody = styled.div`
 background-color: ${COLORS.white};
 padding: 12px 24px;
 border-bottom-left-radius: 8px;
 border-bottom-right-radius: 8px;

 ${InputStyle} {
    ${LabelText} {
        display: none;
    }
 }
p {
    color: ${COLORS.secondary1};
    }

    ${DropdownWindow} {
        width: calc(100% + 36px);
    }
`